(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  /* Theme editor: handle section reload for marquee restart and Alpine re-init */
  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    function handleAnnouncementBarReload(e) {
      var section = e.target || e.detail && e.detail.sectionId && document.getElementById('shopify-section-' + e.detail.sectionId);
      if (!section) return;
      var bar = section.querySelector('.announcement-bar');
      if (!bar) return;

      /* Restart marquee CSS animation */
      var track = bar.querySelector('.announcement-bar__marquee-track');
      if (track) {
        track.style.animation = 'none';
        void track.offsetHeight;
        track.style.animation = '';
      }

      /* Force Alpine to initialize new x-data in replaced section */
      try { if (window.Alpine) window.Alpine.initTree(bar); } catch(err) {}
    }
    document.addEventListener('shopify:section:load', handleAnnouncementBarReload);
    document.addEventListener('shopify:section:rerender', handleAnnouncementBarReload);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-section"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.faq-section[data-single-open="true"]').forEach(function(section) {
    section.addEventListener('click', function(e) {
      var summary = e.target.closest('summary');
      if (!summary) return;
      var parentDetails = summary.parentElement;
      if (!parentDetails || parentDetails.tagName !== 'DETAILS') return;
      var list = section.querySelector('.faq-section__list');
      if (!list) return;
      list.querySelectorAll('details[open]').forEach(function(details) {
        if (details !== parentDetails) {
          details.removeAttribute('open');
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["info-section"] && !Shopify.designMode) return;
  try {
    
  // Cursor parallax for info section background images.
  // Moves bg image opposite to cursor for premium depth effect.
  // Production-ready: cached rect, rAF throttle, reduced-motion,
  // hover-only, AbortController cleanup on section unload.
  (function() {
    var SHIFT = 10;
    var canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!canHover || prefersReduced) return;

    function initParallax(section) {
      var img = section.querySelector('.infos__bg-img');
      if (!img) return;

      var ac = new AbortController();
      var signal = ac.signal;
      var raf = null;
      var tx = 0;
      var ty = 0;
      var cachedRect = null;

      // Cache rect on enter, avoids layout thrash on every mousemove
      section.addEventListener('mouseenter', function() {
        cachedRect = section.getBoundingClientRect();
      }, { signal: signal });

      section.addEventListener('mousemove', function(e) {
        if (!cachedRect) cachedRect = section.getBoundingClientRect();
        var nx = ((e.clientX - cachedRect.left) / cachedRect.width - 0.5) * 2;
        var ny = ((e.clientY - cachedRect.top) / cachedRect.height - 0.5) * 2;
        tx = -nx * SHIFT;
        ty = -ny * SHIFT;
        if (!raf) {
          raf = requestAnimationFrame(function() {
            img.style.transform = 'scale(1.05) translate(' + tx + 'px, ' + ty + 'px)';
            raf = null;
          });
        }
      }, { signal: signal, passive: true });

      section.addEventListener('mouseleave', function() {
        if (raf) { cancelAnimationFrame(raf); raf = null; }
        cachedRect = null;
        img.style.transform = '';
      }, { signal: signal });

      // Store cleanup for Shopify section unload
      section._infosCleanup = function() {
        ac.abort();
        if (raf) cancelAnimationFrame(raf);
        img.style.transform = '';
      };
    }

    function initAll() {
      document.querySelectorAll('.infos--has-bg').forEach(initParallax);
    }

    // Init on load
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    // Shopify editor: cleanup old listeners on section unload, re-init on load
    document.addEventListener('shopify:section:unload', function(e) {
      var el = e.target;
      if (!el) return;
      var s = el.querySelector('.infos--has-bg');
      if (s && s._infosCleanup) { s._infosCleanup(); s._infosCleanup = null; }
    });
    document.addEventListener('shopify:section:load', function(e) {
      var el = e.target;
      if (!el) return;
      var s = el.querySelector('.infos--has-bg');
      if (s) initParallax(s);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lookbook-section"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('alpine:init', function() {
    window.Alpine.data('lookbookItem', function() {
      return {
        isOpen: false,

        toggle: function() {
          this.isOpen = !this.isOpen;
        },

        open: function() {
          this.isOpen = true;
        },

        close: function() {
          this.isOpen = false;
        }
      };
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quick-order-section"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('alpine:init', function () {
    window.Alpine.data('quickOrder', function () {
      return {
        quantities: {},
        adding: {},
        added: {},
        bulkAdding: false,

        get totalItems() {
          var total = 0;
          var q = this.quantities;
          for (var key in q) {
            if (q.hasOwnProperty(key) && q[key] > 0) {
              total += q[key];
            }
          }
          return total;
        },

        get bulkSummary() {
          var count = this.totalItems;
          return count + ' ' + (count === 1 ? 'item' : 'items') + ' selected';
        },

        getQty: function (variantId) {
          return this.quantities[variantId] || 0;
        },

        setQty: function (variantId, value) {
          var v = Math.max(0, Math.min(99, value));
          this.quantities[variantId] = v;
        },

        increment: function (variantId) {
          var current = this.getQty(variantId);
          if (current < 99) {
            this.quantities[variantId] = current + 1;
          }
        },

        decrement: function (variantId) {
          var current = this.getQty(variantId);
          if (current > 0) {
            this.quantities[variantId] = current - 1;
          }
        },

        addSingle: function (variantId) {
          var qty = this.getQty(variantId);
          if (qty <= 0 || this.adding[variantId]) return;

          var self = this;
          self.adding[variantId] = true;

          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              items: [{ id: variantId, quantity: qty }]
            })
          })
          .then(function (res) {
            if (!res.ok) throw new Error('Failed to add');
            return res.json();
          })
          .then(function () {
            self.adding[variantId] = false;
            self.added[variantId] = true;
            self.quantities[variantId] = 0;
            if (window.Alpine.store('cart') && window.Alpine.store('cart').refresh) {
              window.Alpine.store('cart').refresh();
            }
            setTimeout(function () { self.added[variantId] = false; }, 2000);
          })
          .catch(function () {
            self.adding[variantId] = false;
          });
        },

        addAll: function () {
          if (this.bulkAdding || this.totalItems === 0) return;

          var self = this;
          var items = [];
          var q = this.quantities;
          for (var key in q) {
            if (q.hasOwnProperty(key) && q[key] > 0) {
              items.push({ id: parseInt(key), quantity: q[key] });
            }
          }
          if (items.length === 0) return;

          self.bulkAdding = true;

          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: items })
          })
          .then(function (res) {
            if (!res.ok) throw new Error('Failed to add');
            return res.json();
          })
          .then(function () {
            self.bulkAdding = false;
            self.quantities = {};
            if (window.Alpine.store('cart') && window.Alpine.store('cart').refresh) {
              window.Alpine.store('cart').refresh();
            }
          })
          .catch(function () {
            self.bulkAdding = false;
          });
        }
      };
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recently-viewed-section"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('alpine:init', function() {
    window.Alpine.data('recentlyViewed', function(config) {
      return {
        products: [],
        storageKey: 'nukes_recently_viewed',
        max: config.max || 8,
        atStart: true,
        atEnd: false,
        canScroll: false,
        currentDot: 1,
        totalDots: 0,

        init: function() {
          this.loadProducts();
        },

        onScroll: function() {
          var track = this.$refs.track;
          if (!track) return;
          this.atStart = track.scrollLeft <= 4;
          this.atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
          var slideW = track.querySelector('.rv__slide');
          if (slideW) {
            var itemW = slideW.offsetWidth + parseInt(getComputedStyle(track).gap || '0', 10);
            if (itemW > 0) {
              this.currentDot = Math.round(track.scrollLeft / itemW) + 1;
            }
          }
        },

        scrollPrev: function() {
          var track = this.$refs.track;
          if (!track) return;
          track.scrollBy({ left: -track.clientWidth * 0.8, behavior: 'smooth' });
        },

        scrollNext: function() {
          var track = this.$refs.track;
          if (!track) return;
          track.scrollBy({ left: track.clientWidth * 0.8, behavior: 'smooth' });
        },

        scrollToDot: function(dot) {
          var track = this.$refs.track;
          if (!track) return;
          var slide = track.querySelector('.rv__slide');
          if (!slide) return;
          var itemW = slide.offsetWidth + parseInt(getComputedStyle(track).gap || '0', 10);
          track.scrollTo({ left: (dot - 1) * itemW, behavior: 'smooth' });
        },

        updateNav: function() {
          var self = this;
          self.$nextTick(function() {
            var track = self.$refs.track;
            if (!track) return;
            self.canScroll = track.scrollWidth > track.clientWidth + 4;
            var slide = track.querySelector('.rv__slide');
            if (slide) {
              var itemW = slide.offsetWidth + parseInt(getComputedStyle(track).gap || '0', 10);
              self.totalDots = itemW > 0 ? Math.ceil(self.products.length - Math.floor(track.clientWidth / itemW) + 1) : 0;
              if (self.totalDots < 1) self.totalDots = 0;
            }
            self.onScroll();
          });
        },

        getStoredHandles: function() {
          try {
            var stored = localStorage.getItem(this.storageKey);
            if (stored) return JSON.parse(stored);
          } catch (e) {}
          return [];
        },

        loadProducts: function() {
          var self = this;
          var handles = this.getStoredHandles();

          var currentHandle = '';
          var pathParts = window.location.pathname.split('/products/');
          if (pathParts.length > 1) {
            currentHandle = pathParts[1].split('?')[0].split('#')[0];
          }
          handles = handles.filter(function(h) { return h !== currentHandle; });
          handles = handles.slice(0, self.max);
          if (handles.length === 0) return;

          var fmt = window.formatMoney || function(cents) {
            return (cents / 100).toLocaleString(undefined, {
              style: 'currency',
              currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD'
            });
          };

          var CACHE_KEY = 'nukes_rv_cache';
          var cache = {};
          try { cache = JSON.parse(sessionStorage.getItem(CACHE_KEY) || '{}'); } catch(e) {}

          var promises = handles.map(function(handle) {
            if (cache[handle]) return Promise.resolve(cache[handle]);
            return fetch('/products/' + handle + '.json')
              .then(function(r) { if (!r.ok) throw new Error(); return r.json(); })
              .then(function(data) {
                var p = data.product;
                var img = (p.images && p.images.length > 0) ? p.images[0].src : '';
                var img2 = (p.images && p.images.length > 1) ? p.images[1].src : '';
                var price = Math.round(parseFloat(p.variants[0].price) * 100);
                var compare = p.variants[0].compare_at_price ? Math.round(parseFloat(p.variants[0].compare_at_price) * 100) : 0;
                return {
                  handle: p.handle,
                  title: p.title,
                  vendor: p.vendor,
                  url: '/products/' + p.handle,
                  image: img,
                  image2: img2,
                  formattedPrice: fmt(price),
                  formattedCompare: compare > price ? fmt(compare) : '',
                  comparePrice: compare > price
                };
              })
              .then(function(product) {
                if (product) {
                  cache[handle] = product;
                  try { sessionStorage.setItem(CACHE_KEY, JSON.stringify(cache)); } catch(e) {}
                }
                return product;
              })
              .catch(function() { return null; });
          });

          Promise.all(promises).then(function(results) {
            self.products = results.filter(function(p) { return p !== null; });
            self.updateNav();
          });
        },

        destroy: function() { this.products = []; }
      };
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recommended-products-section"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('alpine:init', function() {
    window.Alpine.data('recommendedProducts', function() {
      return {
        loaded: false,

        init: function() {
          var el = this.$root;
          var productId = el.dataset.rpProductId;
          var limit = parseInt(el.dataset.rpLimit, 10) || 8;
          var sectionId = el.dataset.rpSectionId;
          var grid = el.querySelector('[data-rp-grid]');
          var self = this;

          if (!productId || !grid) return;

          /* Primary: Section Rendering API — returns server-rendered product cards */
          var url = '/recommendations/products?product_id=' + productId
            + '&limit=' + limit
            + '&section_id=' + sectionId;

          fetch(url)
            .then(function(response) {
              if (!response.ok) throw new Error('Failed to load');
              return response.text();
            })
            .then(function(html) {
              var parser = new DOMParser();
              var doc = parser.parseFromString(html, 'text/html');
              var cards = doc.querySelectorAll('[data-rp-card]');

              if (cards.length === 0) {
                self.fetchFallback(productId, limit, grid, el);
                return;
              }

              /* Inject server-rendered cards safely using DOM APIs */
              cards.forEach(function(card) {
                var item = document.createElement('div');
                item.className = 'rp__item';
                item.setAttribute('role', 'listitem');
                /* Clone child nodes from the parsed card into the item */
                while (card.firstChild) {
                  item.appendChild(card.firstChild);
                }
                grid.appendChild(item);
              });

              el.style.display = '';
              self.loaded = true;
            })
            .catch(function() {
              self.fetchFallback(productId, limit, grid, el);
            });
        },

        fetchFallback: function(productId, limit, grid, el) {
          var self = this;

          /* Fallback: JSON API — build minimal cards from raw data */
          fetch('/recommendations/products.json?product_id=' + productId + '&limit=' + limit)
            .then(function(response) {
              if (!response.ok) throw new Error('Failed');
              return response.json();
            })
            .then(function(data) {
              if (!data.products || data.products.length === 0) return;

              var fmt = window.formatMoney || function(cents) {
                return (cents / 100).toLocaleString(undefined, {
                  style: 'currency',
                  currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD'
                });
              };

              data.products.forEach(function(p) {
                var imgSrc = p.images && p.images.length > 0 ? p.images[0].src : '';
                var price = Math.round(parseFloat(p.variants[0].price) * 100);
                var compareAt = p.variants[0].compare_at_price ? Math.round(parseFloat(p.variants[0].compare_at_price) * 100) : null;

                var item = document.createElement('div');
                item.className = 'rp__item';
                item.setAttribute('role', 'listitem');

                var link = document.createElement('a');
                link.href = '/products/' + p.handle;
                link.className = 'rp__card';

                /* Image */
                var media = document.createElement('div');
                media.className = 'rp__media';
                if (imgSrc) {
                  var img = document.createElement('img');
                  img.src = imgSrc + '&width=600';
                  img.alt = p.title || '';
                  img.width = 400;
                  img.height = 400;
                  img.loading = 'lazy';
                  media.appendChild(img);
                }
                link.appendChild(media);

                /* Info */
                var info = document.createElement('div');
                info.className = 'rp__info';

                if (p.vendor) {
                  var vendor = document.createElement('p');
                  vendor.className = 'rp__vendor';
                  vendor.textContent = p.vendor;
                  info.appendChild(vendor);
                }

                var title = document.createElement('h3');
                title.className = 'rp__title';
                title.textContent = p.title;
                info.appendChild(title);

                var priceRow = document.createElement('div');
                priceRow.className = 'rp__price-row';
                var priceEl = document.createElement('span');
                priceEl.className = compareAt && compareAt > price ? 'rp__price rp__price--sale' : 'rp__price';
                priceEl.textContent = fmt(price);
                priceRow.appendChild(priceEl);

                if (compareAt && compareAt > price) {
                  var cmpEl = document.createElement('span');
                  cmpEl.className = 'rp__price rp__price--compare';
                  cmpEl.textContent = fmt(compareAt);
                  priceRow.appendChild(cmpEl);
                }
                info.appendChild(priceRow);

                link.appendChild(info);
                item.appendChild(link);
                grid.appendChild(item);
              });

              el.style.display = '';
              self.loaded = true;
            })
            .catch(function() {});
        }
      };
    });
  });

  } catch(e) { console.error(e); }
})();
})();
